import React from 'react';
import get from 'lodash/get';

import { Wrapper, Title, Body } from './style';

export default ({ title, body }) => {
  return (
    <Wrapper>
      {title && title.length ? <Title>{title}</Title> : null}
      <Body
        dangerouslySetInnerHTML={{
          __html: get(body, 'childMarkdownRemark.html'),
        }}
      />
    </Wrapper>
  );
};
